import React, { useReducer, useCallback, useMemo, ReactNode } from 'react';
import { MenuContext, menuReducer, initialState } from './MenuContextUtils';

interface MenuProviderProps {
  children: ReactNode;
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(menuReducer, initialState);

  const setContainerClassnames = useCallback((clickCount: number, classnames: string, hasSubItems: boolean) => {
    dispatch({ type: 'SET_CONTAINER_CLASSNAMES', payload: { clickCount, classnames, hasSubItems } });
  }, []);

  const clickOnMobileMenu = useCallback((classnames: string, clickCount: number) => {
    dispatch({ type: 'CLICK_MOBILE_MENU', payload: { classnames, clickCount } });
  }, []);

  const addContainerClassname = useCallback((classname: string) => {
    dispatch({ type: 'ADD_CONTAINER_CLASSNAME', payload: { classname } });
  }, []);

  const changeDefaultClassnames = useCallback((classnames: string) => {
    dispatch({ type: 'CHANGE_DEFAULT_CLASSNAMES', payload: { classnames } });
  }, []);

  const changeSelectedMenuHasSubItems = useCallback((hasSubItems: boolean) => {
    dispatch({ type: 'CHANGE_SELECTED_MENU_HAS_SUB_ITEMS', payload: { hasSubItems } });
  }, []);

  const toggleMenu = useCallback(() => {
    dispatch({ type: 'TOGGLE_MENU' });
  }, []);

  const value = useMemo(() => ({
    ...state,
    setContainerClassnames,
    clickOnMobileMenu,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
    toggleMenu,
  }), [
    state,
    setContainerClassnames,
    clickOnMobileMenu,
    addContainerClassname,
    changeDefaultClassnames,
    changeSelectedMenuHasSubItems,
    toggleMenu,
  ]);

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

